import React, { useState, useEffect, useRef } from "react";
import {
  Select, InputNumber, Input, Button, Radio, Divider, Spin, message, Alert,
} from "antd";
import HmacSHA256 from "crypto-js/hmac-sha256";
import Base64 from "crypto-js/enc-base64";
import CryptoJSCore from "crypto-js/core";
import axios, { getCurrentEnv } from "../../axiosConfig";
import { saveAs } from "file-saver";

const API_URLS = {
  prod: "https://prod-api.nick.academy/api",
  dev: "https://dev-api.nick.academy/api",
};

const HMAC_KEYS = {
  prod: "nickacademyPRODemailKey%#8@%sd%$0D^GA$#JH1F",
  dev: "nickacademyDEVemailKey#@!%$6tcaAA%weSGGaAN",
};

const PRO_CHILD_PROGRESS = (uuid) => ({
  uuid,
  progress_courses_indexes: [
    [{ index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }],
    [{ index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }],
    [{ index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }],
    [{ index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }, { index: 4, trophies: 3 }],
  ],
  progress_escaperoom_indexes: [
    { trophies: 3, escaperoom_id: "Adv-FTK111990bf" },
    { trophies: 3, escaperoom_id: "Adv-LL222022bf" },
    { trophies: 3, escaperoom_id: "Adv-SO240722bf" },
  ],
  one_time_visit_locations: [
    "f_time_profiletutorialpassed", "f_time_lobby", "f_time_lisaspeech",
    "f_time_advanchers", "f_time_subject", "f_time_lincolnspeech",
    "robots_room_tutorial_passed",
  ],
  past_microgames: [
    { id: "ARCSM1L12bf1", score: 10, status: "pass" },
    { id: "ARCSM4L124511", score: 10, status: "pass" },
    { id: "ARCSM4L124512", score: 10, status: "pass" },
    { id: "ARCSM1L12117bf2", score: 10, status: "pass" },
    { id: "ARCSM1L12117bf8", score: 10, status: "pass" },
    { id: "ARCSM1L22120bf2", score: 10, status: "pass" },
    { id: "ARCSM1L32123bf2", score: 10, status: "pass" },
    { id: "ARCSM1L32123bf6", score: 10, status: "pass" },
    { id: "ARCSM1L42126bf2", score: 10, status: "pass" },
    { id: "ARCSM2L124401", score: 10, status: "pass" },
    { id: "ARCSM2L124407", score: 10, status: "pass" },
    { id: "ARCSM2L224433", score: 10, status: "pass" },
    { id: "ARCSM2L224436", score: 10, status: "pass" },
    { id: "ARCSM2L324463", score: 10, status: "pass" },
    { id: "ARCSM2L3244611", score: 10, status: "pass" },
    { id: "ARCSM2L424492", score: 10, status: "pass" },
    { id: "ARCSM2L424497", score: 10, status: "pass" },
  ],
  total_trophies: 200,
});

function generatePassword(length = 8) {
  const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
  let pw = "";
  for (let i = 0; i < length; i++) {
    pw += chars[Math.floor(Math.random() * chars.length)];
  }
  return pw;
}

function generateUserEmailToken(email, env) {
  const timestamp = Math.floor(Date.now() / 1000);
  const data = `${email}:${timestamp}`;
  const key = HMAC_KEYS[env];
  const signature = HmacSHA256(data, key).toString();
  const token = `${email}:${timestamp}:${signature}`;
  const bytes = [];
  for (let i = 0; i < token.length; i++) {
    bytes.push(token.charCodeAt(i));
  }
  const wordArr = [];
  for (let i = 0; i < bytes.length; i += 4) {
    wordArr.push(
      (bytes[i] << 24) | ((bytes[i + 1] || 0) << 16) | ((bytes[i + 2] || 0) << 8) | (bytes[i + 3] || 0)
    );
  }
  const wa = CryptoJSCore.lib.WordArray.create(wordArr, bytes.length);
  let encoded = Base64.stringify(wa);
  encoded = encoded.replace(/=/g, "");
  encoded = encoded
    .replace(/:/g, "-")
    .replace(/\?/g, "_")
    .replace(/&/g, "~")
    .replace(/%/g, "*")
    .replace(/\+/g, ".")
    .replace(/\//g, ",");
  return encoded;
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default function UserCreation() {
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [coupons, setCoupons] = useState([]);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [numUsers, setNumUsers] = useState(1);
  const [emailTemplate, setEmailTemplate] = useState("guest${userNumber}@nick.academy");
  const [startMode, setStartMode] = useState("auto");
  const [customStart, setCustomStart] = useState(1);
  const [passwordMode, setPasswordMode] = useState("generated");
  const [simplePassword, setSimplePassword] = useState("");
  const [running, setRunning] = useState(false);
  const [log, setLog] = useState([]);
  const [terminalRows, setTerminalRows] = useState([]);
  const [progress, setProgress] = useState({ done: 0, total: 0 });
  const [finished, setFinished] = useState(false);
  const [copied, setCopied] = useState(false);
  const csvData = useRef([]);
  const logEndRef = useRef(null);
  const terminalEndRef = useRef(null);
  const stopRef = useRef(false);

  useEffect(() => {
    axios.get("/vendors/all/").then((res) => {
      setVendors(res.data.vendors || []);
    });
  }, []);

  function onVendorSelect(vendorId) {
    setSelectedVendor(vendorId);
    setSelectedCoupon(null);
    setCoupons([]);
    axios.get(`/coupons/vendorid/?vendor_id=${vendorId}`).then((res) => {
      setCoupons(res.data || []);
    });
  }

  const couponObj = coupons.find((c) => c.coupon_id === selectedCoupon);
  const available = couponObj ? couponObj.usage_limit - couponObj.usage_count : 0;
  const notEnough = couponObj && available < numUsers;

  const startNumber = startMode === "auto" && couponObj
    ? couponObj.usage_count + 1
    : customStart;

  function addLog(text, type = "info") {
    setLog((prev) => [...prev, { text, type, time: new Date().toLocaleTimeString() }]);
  }

  useEffect(() => {
    logEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [log]);

  useEffect(() => {
    terminalEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [terminalRows]);

  function getEmailFromTemplate(userNumber) {
    return emailTemplate.replace(/\$\{userNumber\}/g, userNumber);
  }

  async function handleCreate() {
    if (!selectedCoupon || !numUsers || notEnough) return;
    if (passwordMode === "simple" && !simplePassword) {
      message.warning("Enter a password");
      return;
    }
    if (!emailTemplate.includes("${userNumber}")) {
      message.warning("Email template must include ${userNumber}");
      return;
    }

    setRunning(true);
    setFinished(false);
    setLog([]);
    setTerminalRows([]);
    setProgress({ done: 0, total: numUsers });
    csvData.current = [];
    stopRef.current = false;

    const env = getCurrentEnv();
    const baseUrl = API_URLS[env];

    addLog(`Starting creation of ${numUsers} users (env: ${env.toUpperCase()})`);

    let userNum = startNumber;

    for (let i = 0; i < numUsers; i++) {
      if (stopRef.current) {
        addLog(`Stopped by user after ${i} users.`, "error");
        break;
      }
      const email = getEmailFromTemplate(userNum);
      const password = passwordMode === "simple" ? simplePassword : generatePassword(8);

      try {
        addLog(`[${i + 1}/${numUsers}] Registering ${email}...`);
        await fetch(`${baseUrl}/users/api-register/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email,
            password1: password,
            password2: password,
            user_type: "p",
            terms_accepted: true,
            newsletter_optin: true,
            coupon_id: selectedCoupon,
          }),
        }).then((r) => {
          if (!r.ok) throw new Error(`Register failed (${r.status})`);
          return r.json();
        });

        await delay(2);

        const hmac = generateUserEmailToken(email, env);
        await fetch(`${baseUrl}/users/verify-user/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ hmac }),
        }).then((r) => {
          if (!r.ok) throw new Error(`Verify failed (${r.status})`);
          return r.json();
        });

        const loginRes = await fetch(`${baseUrl}/users/api-login/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }).then((r) => {
          if (!r.ok) throw new Error(`Login failed (${r.status})`);
          return r.json();
        });
        const userToken = loginRes.jwt.access;

        const userHeaders = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        };

        await fetch(`${baseUrl}/users/api-child-signup/`, {
          method: "POST",
          headers: userHeaders,
          body: JSON.stringify({ name: "Junior", birthdate: "2015-05-12", password: "1111" }),
        }).then((r) => {
          if (!r.ok) throw new Error(`Junior child failed (${r.status})`);
          return r.json();
        });

        const proRes = await fetch(`${baseUrl}/users/api-child-signup/`, {
          method: "POST",
          headers: userHeaders,
          body: JSON.stringify({ name: "Pro", birthdate: "2015-05-12" }),
        }).then((r) => {
          if (!r.ok) throw new Error(`Pro child failed (${r.status})`);
          return r.json();
        });
        const proUuid = proRes.child_profile.uuid;

        await fetch(`${baseUrl}/users/api-edit-child-profile/`, {
          method: "PUT",
          headers: userHeaders,
          body: JSON.stringify(PRO_CHILD_PROGRESS(proUuid)),
        }).then((r) => {
          if (!r.ok) throw new Error(`Set progress failed (${r.status})`);
          return r.json();
        });

        csvData.current.push({ email, password, coupon_id: selectedCoupon });
        setTerminalRows((prev) => [...prev, `${email},${password}`]);
        addLog(`[${i + 1}/${numUsers}] ${email} — created successfully`, "success");
      } catch (err) {
        addLog(`[${i + 1}/${numUsers}] ${email} — ERROR: ${err.message}`, "error");
      }

      setProgress({ done: i + 1, total: numUsers });
      userNum += 1;
    }

    addLog(`Finished. ${csvData.current.length}/${numUsers} users created successfully.`);
    setRunning(false);
    setFinished(true);
  }

  function downloadCsv() {
    if (csvData.current.length === 0) return;
    const header = "email,password\n";
    const rows = csvData.current.map((r) => `${r.email},${r.password}`).join("\n");
    const blob = new Blob([header + rows], { type: "text/csv;charset=utf-8" });
    saveAs(blob, `users_${new Date().toISOString().slice(0, 10)}.csv`);
  }

  function copyTerminal() {
    if (terminalRows.length === 0) return;
    navigator.clipboard.writeText(terminalRows.join("\n")).then(() => {
      setCopied(true);
      message.success("Copied to clipboard");
      setTimeout(() => setCopied(false), 2000);
    });
  }

  const previewFirst = numUsers > 0 ? getEmailFromTemplate(startNumber) : "";
  const previewLast = numUsers > 1 ? getEmailFromTemplate(startNumber + numUsers - 1) : "";

  return (
    <div style={{ maxWidth: 700, margin: "0 auto" }}>
      <h2>User Creation</h2>

      <Divider orientation="left">Vendor & Coupon</Divider>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>Vendor</label>
        <Select
          placeholder="Select vendor"
          showSearch
          style={{ width: "100%" }}
          onChange={onVendorSelect}
          filterOption={(input, opt) => opt.children.toLowerCase().includes(input.toLowerCase())}
        >
          {vendors.map((v) => (
            <Select.Option key={v.id} value={v.id}>{v.vendor_name}</Select.Option>
          ))}
        </Select>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>Number of users</label>
        <InputNumber
          min={1}
          value={numUsers}
          onChange={(v) => setNumUsers(v)}
          style={{ width: "100%" }}
        />
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>Coupon</label>
        <Select
          placeholder={selectedVendor ? "Select coupon" : "Select a vendor first"}
          style={{ width: "100%" }}
          disabled={!selectedVendor}
          value={selectedCoupon}
          onChange={setSelectedCoupon}
          showSearch
          filterOption={(input, opt) => opt.children.join("").toLowerCase().includes(input.toLowerCase())}
        >
          {coupons.map((c) => (
            <Select.Option key={c.coupon_id} value={c.coupon_id}>
              {c.coupon_id.slice(0, 8)}... — limit: {c.usage_limit}, used: {c.usage_count}, available: {c.usage_limit - c.usage_count}
            </Select.Option>
          ))}
        </Select>
        {notEnough && (
          <Alert
            type="error"
            showIcon
            style={{ marginTop: 8 }}
            message={`Not enough redemptions. Available: ${available}, requested: ${numUsers}`}
          />
        )}
      </div>

      <Divider orientation="left">Email & Password</Divider>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>
          Email template (use {"${userNumber}"} for the number)
        </label>
        <Input
          value={emailTemplate}
          onChange={(e) => setEmailTemplate(e.target.value)}
          placeholder="guest${userNumber}@nick.academy"
        />
        {previewFirst && (
          <div style={{ marginTop: 4, fontSize: 12, color: "#888" }}>
            Preview: {previewFirst}{previewLast ? ` ... ${previewLast}` : ""}
          </div>
        )}
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>Starting user number</label>
        <Radio.Group value={startMode} onChange={(e) => setStartMode(e.target.value)} style={{ marginBottom: 8 }}>
          <Radio value="auto">Auto (from coupon usage: {couponObj ? couponObj.usage_count + 1 : "—"})</Radio>
          <Radio value="custom">Custom</Radio>
        </Radio.Group>
        {startMode === "custom" && (
          <InputNumber min={0} value={customStart} onChange={setCustomStart} style={{ width: "100%" }} />
        )}
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>Password</label>
        <Radio.Group value={passwordMode} onChange={(e) => setPasswordMode(e.target.value)} style={{ marginBottom: 8 }}>
          <Radio value="generated">Generated (random 8 characters)</Radio>
          <Radio value="simple">Simple (same for all)</Radio>
        </Radio.Group>
        {passwordMode === "simple" && (
          <Input
            value={simplePassword}
            onChange={(e) => setSimplePassword(e.target.value)}
            placeholder="Enter password"
          />
        )}
      </div>

      <div style={{ marginBottom: 12 }}>
        <Button
          type="primary"
          size="large"
          block
          onClick={handleCreate}
          disabled={running || !selectedCoupon || !numUsers || notEnough}
          loading={running}
        >
          {running ? `Creating... (${progress.done}/${progress.total})` : "Create Users"}
        </Button>
      </div>

      {running && (
        <div style={{ marginBottom: 24 }}>
          <Button
            danger
            size="large"
            block
            onClick={() => { stopRef.current = true; }}
          >
            Stop
          </Button>
        </div>
      )}

      {terminalRows.length > 0 && (
        <>
          <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
            <Button onClick={copyTerminal}>
              {copied ? "Copied!" : "Copy All"}
            </Button>
            <Button onClick={downloadCsv}>
              Download CSV ({csvData.current.length} users)
            </Button>
          </div>
          <div
            style={{
              maxHeight: 300,
              overflowY: "auto",
              borderRadius: 4,
              padding: 12,
              fontSize: 13,
              fontFamily: "monospace",
              background: "#1e1e1e",
              color: "#d4d4d4",
              marginBottom: 16,
            }}
          >
            {terminalRows.map((row, i) => (
              <div key={i}>{row}</div>
            ))}
            <div ref={terminalEndRef} />
          </div>
        </>
      )}

      {log.length > 0 && (
        <>
          <Divider orientation="left">Progress Log</Divider>
          <div
            style={{
              maxHeight: 200,
              overflowY: "auto",
              border: "1px solid #d9d9d9",
              borderRadius: 4,
              padding: 12,
              fontSize: 12,
              fontFamily: "monospace",
              background: "#fafafa",
            }}
          >
            {log.map((entry, i) => (
              <div
                key={i}
                style={{
                  color: entry.type === "error" ? "#f5222d" : entry.type === "success" ? "#52c41a" : undefined,
                  marginBottom: 2,
                }}
              >
                <span style={{ color: "#999", marginRight: 8 }}>{entry.time}</span>
                {entry.text}
              </div>
            ))}
            <div ref={logEndRef} />
          </div>
        </>
      )}
    </div>
  );
}
